import ReactDOM from 'react-dom'
import React, {useState, useEffect, useRef} from 'react'
import VATFormStyles from './css/VATFormStyles'

function VATForm(props) {
  const { vatSettings, updateVATSettings } = props
  const [vat, setVat] = useState((vatSettings) ? vatSettings.value : null)
  const vatInputRef = useRef(null)

  const onClick = async (button) => {
    if (button === 'Apply') await updateVATSettings(vat)
    ReactDOM.unmountComponentAtNode(document.getElementById('modal-form-container'))
  }

  useEffect(() => { vatInputRef.current.focus() })

  return (
    <React.Fragment>
      <div id='vat-form-container'>
        <div id='vat-input-form'>
          <label>VAT %</label>
          <input
            ref={vatInputRef}
            id='vat-input'
            type='number'
            value={vat}
            min='0'
            className='top-anchor'
            onChange={(e) => { (e.target.value) ? setVat(parseFloat(e.target.value)) : setVat('') }}
          />
        </div>
        <div className='button-group-container'>
          <button
            id='btn-apply'
            onClick={(e) => { onClick('Apply') }}
            className='pospro-action-btn'>
            Apply
          </button>
          <button
            id='btn-cancel'
            onClick={(e) => { onClick('Cancl') }}
            className='pospro-action-btn bottom-anchor'>
            Cancel
          </button>
        </div>
      </div>
      <VATFormStyles />
    </React.Fragment>
  )
}

export default React.memo(VATForm)